import { MATERIAL_DOCUMENT_LIST, MATERIAL_DOCUMENT_ID } from '../actions/MaterialActions'

function initialState() {
  return {
    documentId: {},
    documents: [],
  }
}

export default function materials(state = initialState(), action) {
  switch (action.type) {
    case MATERIAL_DOCUMENT_LIST:
      return state ? { ...state, documents: action.payload } : { documents: action.payload }
    case MATERIAL_DOCUMENT_ID:
      return state ? { ...state, documentId: action.payload } : { documentId: action.payload }
    default:
      return state
  }
}
